const url = process.env.REACT_APP_API_URL;

export const Constants = {
	url: url,
	baseUrl: url + "/api/profissional",
	pagarme_server: process.env.REACT_APP_PAGARME_SERVER_PAYMENT,
	pagarme_public: process.env.REACT_APP_PAGARME_PUBLIC_KEY,
};

export const ESPECIALIDADES = [
	'Analista comportamental',
	'Aplicador ABA',
	'Arteterapeuta',
	'Assistente terapêutico (AT)',
	'Babá / Cuidador',
	'Educador físico',
	'Equoterapeuta',
	'Fisioterapeuta',
	'Fonoaudiólogo',
	'Mediador',
	'Musicoterapeuta',
	'Neuropediatra',
	'Neuropsicólogo',
	'Neuropsicopedagogo',
	'Nutricionista ',
	'Nutrólogo ',
	'Odontopediatra',
	'Pedagogo',
	'Pediatra',
	'Professor',
	'Psicólogo',
	'Psicomotricista',
	'Psicopedagogo',
	'Psiquiatra',
	'Terapeuta ocupacional',
	'Outro',
];